import { getNMaxGroupName } from "../nmax"
import { IDashboardNutrition, IDashboardService } from "../types"
import { CroppingInfo } from "./cropping-info"
import { NotificationGroup } from "./types"

export function checkRequirementsToRecalc(ids: number[] = [], cropping: CroppingInfo[]): NotificationGroup {

    let details = ids.map(id => {
        const c = cropping.find(i => i.croppingId == id)
        if (c) {
            return {
                text: c.description,
            }
        }
    }).filter(d => !!d).sort((d1, d2) => d1.text.localeCompare(d2.text))

    if (details.length) {

        return {
            id: "nutrition-requirements-recalc",
            summary: "Crop requirements must be recalculated",
            description: `
                <p>You have changed parameters that affect the crop requirements for the following crops</p>
                <p>You need to recalculate the crop requirements for the these changes to be taken into account. Please note that the plans will also need to be recalculated for the new requirements to be taken into account.</p>
                `,
            error: false,
            details: details,
        };

    }

}

export function checkFarmNLoading(nvz: boolean, status: IDashboardNutrition): NotificationGroup {

    if (!nvz) return null;
    if (!status) return null;

    let nloading = status.MMP;
    if (!nloading) return null;
    if (nloading.NLoading <= nloading.NLimit) return null;

    return {
        id: "mmp-farm-n-loading",
        summary: "Farm manure (N) loading exceeds the limit.",
        description: `The actual farm organic N loading (farm limit) is <span class='error'>${nloading.NLoading} kg/ha</span>, but should be at most ${nloading.NLimit} kg/ha.`,
        error: true,
        details: []
    };

}

export function checkNMaxCompliance(svc: IDashboardService, status: IDashboardNutrition): NotificationGroup {

    if (!status) return null;

    let issues = status.NMax.filter(group => {

        if (group.NAppliedAverage > group.NMaxAverage) return true;
        if (group.NRequiredAverage > group.NMaxAverage) return true;
        return false;

    });

    if (!issues.length) {
        return null;
    }

    let details = issues.map(i => {

        const groupName = getNMaxGroupName(i, svc)

        return {
            text: `${groupName}: limit: ${i.NMaxAverage}, ${getValueText("required", i.NMaxAverage, i.NRequiredAverage)}, ${getValueText("applied", i.NMaxAverage, i.NAppliedAverage)}`,
        }

    });

    return {
        id: "nvz-status",
        summary: "This holding breaks the N max limit",
        description: "Some of the crop groups on this holding break the N max limit.",
        error: true,
        details: details,
    };

}

function getValueText(prefix: string, avg: number, value: number) {
    if (avg >= value) return prefix + ": " + value + "  kg/ha";
    return `<span class='error'>${prefix}: ${value} kg/ha</span>`;
}
